/** Shopify CDN: Minification failed

Line 92:43 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 93:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 98:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 98:22 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 99:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 107:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 115:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 139:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 144:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 153:30 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 14 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 77:43 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 78:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 83:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 83:22 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 84:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 92:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 100:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 124:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 129:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 138:30 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 14 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 62:43 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 63:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 68:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 68:22 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 69:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 77:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 85:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 109:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 114:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 123:30 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 14 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 47:43 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 48:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 53:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 53:22 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 54:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 62:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 70:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 94:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 99:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 108:30 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 14 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 32:43 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 33:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 38:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 38:22 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 39:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 47:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 55:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 79:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 84:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 93:30 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 14 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 17:43 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 18:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 23:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 23:22 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 24:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 32:8 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 40:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 64:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 69:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 78:30 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 14 more hidden warnings

**/
if (!customElements.get('quick-add-modal')) {
  customElements.define('quick-add-modal', class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
    }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      fetch(opener.getAttribute('data-product-url'))
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.removeGalleryListSemantic();
          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    removeDOMElements() {
      const pickupAvailability = this.productElement.querySelector('pickup-availability');
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector('product-modal');
      if (productModal) productModal.remove();

      const modalDialog = this.productElement.querySelectorAll('modal-dialog');
      if (modalDialog) modalDialog.forEach(modal => modal.remove());
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${ sectionId }`);
      this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
        element.dataset.originalSection = sectionId;
      });
    }

    removeGalleryListSemantic() {
      const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
      if (!galleryList) return;

      galleryList.setAttribute('role', 'presentation');
      galleryList.querySelectorAll('[id^="Slide-"]').forEach(li => li.setAttribute('role', 'presentation'));
    }

    updateImageSizes() {
      const product = this.modalContent.querySelector('.product');
      const desktopColumns = product.classList.contains('product--columns');
      if (!desktopColumns) return;

      const mediaImages = product.querySelectorAll('.product__media img');
      if (!mediaImages.length) return;

      let mediaImageSizes = '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';
      
      if (product.classList.contains('product--medium')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '605px');
      } else if (product.classList.contains('product--small')) {
        mediaImageSizes = mediaImageSizes.replace('715px', '495px');
      }

      mediaImages.forEach(img => img.setAttribute('sizes', mediaImageSizes));
    }
  });
}
